import { MembershipEmployeeRange } from "./settingsData";

type EmployeeRangeIssue = {
  rangeId: string;
  message: string;
};

const isEmployeeCount = (value: string) =>
  /^\d+$/.test(value.trim()) && Number.isSafeInteger(Number(value)) && Number(value) >= 1;

export const getMembershipEmployeeRangeIssues = (
  ranges: MembershipEmployeeRange[]
): EmployeeRangeIssue[] => {
  const issues: EmployeeRangeIssue[] = [];

  ranges.forEach((range, index) => {
    const from = Number(range.from);
    const to = Number(range.to);
    const previousRange = ranges[index - 1];
    let message = "";

    if (!isEmployeeCount(range.from)) {
      message = "Enter a whole employee count of one or more.";
    } else if (!range.to.trim() && index < ranges.length - 1) {
      message = "Enter an end count. Only the last range can be open-ended.";
    } else if (range.to.trim() && (!isEmployeeCount(range.to) || to < from)) {
      message = "Enter a whole end count equal to or above the start count.";
    } else if (previousRange && isEmployeeCount(previousRange.to)) {
      const previousEnd = Number(previousRange.to);
      if (from <= previousEnd) {
        message = `This range overlaps the previous range. Start at ${previousEnd + 1}.`;
      } else if (from > previousEnd + 1) {
        message = `This range leaves a gap. Start at ${previousEnd + 1}.`;
      }
    }

    if (message) issues.push({ rangeId: range.id, message });
  });

  return issues;
};
